import * as React from "react";
import { cn } from "../../lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextArea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, value, onChange, ...props }, ref) => {
    const [textAreaHeight, setTextAreaHeight] = React.useState("auto");

    // Function to adjust textarea height based on content
    const adjustHeight = (target: HTMLTextAreaElement) => {
      setTextAreaHeight("auto"); // Reset to auto before recalculating
      setTextAreaHeight(target.value ? `${target.scrollHeight}px` : "auto");
    };

    // Adjust height when typing or when prefilled (via value prop)
    const handleInput = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      adjustHeight(event.target);
      if (onChange) {
        onChange(event);
      }
    };

    return (
      <textarea
        ref={ref}
        className={cn(
          "flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm resize-vertical overflow-auto ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        style={{ height: textAreaHeight }}
        value={value}
        onInput={handleInput}
        {...props}
      />
    );
  }
);

TextArea.displayName = "TextArea";

export { TextArea };
